import React, { useState } from 'react'
import axios from "axios"

import ProjectText from "../components/ProjectText"
import IconArrow from "../components/IconArrow"
import MainIcon from "../components/MainIcon"

import toaster from "toasted-notes";
import "toasted-notes/src/styles.css";

const Leader = ({page, tag}) => {

    const layout = page;
    const [showModal, setShowModal] = useState(false);

    const [serverState, setServerState] = useState({
        submitting: false,
        status: null
    });

    const handleServerResponse = (ok, msg, form) => {
        setServerState({
            submitting: false,
            status: { ok, msg }
        });
        if (ok) {
            form.reset();
        }
    };

    const handleOnSubmit = e => {
        e.preventDefault();
        const form = e.target;
        setServerState({ submitting: true });
        axios({
            method: "post",
            url: "https://getform.io/f/d44b214a-4ebd-424d-8212-2d938fa8b96c",
            data: new FormData(form)
        })
        .then(r => {
            handleServerResponse(true, "Thanks!", form);
            setShowModal(false);
            toaster.notify("I've received your details, thank you.", {
                position: "bottom",
                duration: 3000
            });
        })
        .catch(r => {
            handleServerResponse(false, r.response.data.error, form);
        });
    }

    return (
        <div className="mt-16 md:mt-32">
            <div className="flex">
                <span className="px-1 tracking-tight text-teal-800 uppercase border-t border-b border-l border-teal-800 rounded-l-sm dark:text-teal-600 md:text-xs text-xxs">Status: </span>
                <span className="px-1 tracking-tight text-white uppercase bg-teal-800 border-t border-b border-r border-teal-800 rounded-r-sm dark:border-teal-600 md:text-xs text-xxs">Available</span>
            </div>

            <div className="mt-8">
                <div className="flex items-center">
                    <div className="sm:hidden">
                        {layout==="home" &&
                        <img className="w-8 h-8 mr-2 border border-gray-700 rounded-full dark:border-gray-400" src="/matt2.jpg" alt="me"/>}
                    </div>
                    <h2 className="block text-3xl font-bold leading-tight tracking-tight md:text-6xl dark:text-BaseLight font-inter">
                        {layout==="home" && "Hello world."}
                        {layout==="tagSubject" && "Projects I've built which use "+tag}
                        {layout==="blog" && "Blog"}
                    </h2>
                </div>
                <div className="flex items-center mt-4">
                    <div className="flex-shrink-0 hidden sm:block sm:mr-4">
                        {layout==="home" && <img className="border border-gray-400 rounded-full sm:h-16 sm:w-16 md:h-16 md:w-16 lg:h-16 lg:w-16" src="/matt2.jpg" alt="me"/>}
                        {layout==="tagSubject" && <span className={'font-bold sm:text-6xl text-'+tag}><MainIcon tag={tag}/></span>}
                        {layout==="blog" && <img className="border border-gray-400 rounded-full sm:h-16 sm:w-16 md:h-16 md:w-16 lg:h-16 lg:w-16" src="/matt2.jpg" alt="me"/>}
                    </div>
                    <div>
                        <p className="w-full md:text-lg lg:w-7/12 dark:text-gray-400 font-ibm">
                            {layout==="home" && "Welcome to my portfolio. Below is a selection of projects I have recently completed. Each project has a GitHub & web link where available. Click tags to view similar projects. Please let me know if you have any questions."}
                            {layout==="tagSubject" && <ProjectText tag={tag}/>}
                            {layout==="blog" && "Here's the blog! This is more an exercise in building a blog than a repo for informative articles, and the posts below shouldn't be thought of as definitive 'how to' guides, not yet anyway 😅"}
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex items-center mt-8">
                <button className="flex items-center px-2 py-1 text-teal-600 border border-teal-600 rounded dark:border-teal-400 dark:text-teal-400 hover:opacity-75" style={{ transition: "all .15s ease" }}>
                    <span className="mr-2 text-sm text-gray-800 dark:text-gray-400"><a href="mailto:matt.heslington@icloud.com">Contact me</a></span>
                    <IconArrow size="3"/>
                </button>


                {showModal ? (
                    <>
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
                        <div className="relative w-auto max-w-3xl mx-auto my-6">
                        {/*content*/}
                            <form onSubmit={handleOnSubmit}>
                                <div className="relative flex flex-col w-full border-0 rounded-lg shadow-lg outline-none bg-BaseDark focus:outline-none">
                                    {/*header*/}
                                    <div className="flex items-start justify-between p-5 rounded-t">
                                        <h3 className="text-2xl font-bold tracking-tight text-teal-400">
                                            Let's Talk <span role="img" aria-label="chat emoji">💬</span>
                                        </h3>
                                        <button className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none" onClick={() => setShowModal(false)}>
                                            <span className="block w-6 h-6 text-2xl bg-transparent outline-none text-BaseLight opacity-5 focus:outline-none">×</span>
                                        </button>
                                    </div>

                                    {/*body*/}
                                    <div className="relative flex-auto p-6">

                                        <div class="">
                                            <label class="ml-1 block text-xs uppercase text-gray-400" htmlFor="name">name</label>
                                            <input class="w-full px-2 py-2 mt-1 bg-black rounded border border-gray-800 focus:ouline-none text-white font-bold tracking-tight" id="name" type="text" name="name" required/>
                                        </div>
                                        <div class="mt-4">
                                            <label class="ml-1 block text-xs uppercase text-gray-400" htmlFor="email">Email address</label>
                                            <input class="w-full px-2 py-2 mt-1 bg-black rounded border border-gray-800 focus:ouline-none text-white font-bold tracking-tight" id="email" type="email" name="email" />
                                        </div>
                                        <div class="mt-4">
                                            <label class="ml-1 block text-xs uppercase text-gray-400" htmlFor="message">Leave a message, I'll get straight back to you</label>
                                            <textarea class="w-full px-2 py-2 mt-1 bg-black rounded border border-gray-800 focus:ouline-none text-white font-bold tracking-tight" name="message" id="message" rows="10"></textarea>
                                        </div>

                                    </div>

                                    {/*footer*/}
                                    <div className="flex items-center justify-center px-6 pb-6 rounded-b">
                                        <button
                                            className="w-full px-6 py-2 mb-1 text-sm font-bold text-white uppercase bg-teal-600 rounded shadow outline-none active:bg-teal-700 hover:shadow-lg focus:outline-none"
                                            type="submit"
                                            style={{ transition: "all .300s ease" }}

                                            disabled={serverState.submitting}
                                        >Send
                                        </button>
                                        {serverState.status && (
                                            <p className={!serverState.status.ok ? "errorMsg" : ""}>
                                                {serverState.status.msg}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="fixed inset-0 z-40 bg-black opacity-50"></div>
                    </>
                ) : null}


            </div>
        </div>
    )
}

export default Leader
